import axios from 'axios';

import handleApiResponse from './utils';

const getCustomFields = async ({ __config, criteria = '' }) => {
	let response = await axios.get(`${__config.data_sources.fhir}/CustomField${criteria}`);
	response = handleApiResponse(response, false);
	return response ? response.data : [];
};

export default getCustomFields;
